import withIntersectionObserver from '../../utils/withIntersectionObserver';
import GridTile from './GridTile.legacy';

export default withIntersectionObserver(0)(GridTile);
